var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c("Header"),
      _c(
        "div",
        { staticClass: "box_steps" },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.active,
                "align-center": "",
                "finish-status": "success",
              },
            },
            [
              _c("el-step", {
                attrs: { title: "类型", description: "选择类型、颜色" },
              }),
              _c("el-step", {
                attrs: {
                  title: "上传",
                  description:
                    "上传如下示例图大小公司的公章、法人章、财务章、法人签字等，上传图片必须保证除印章再无其它元素。",
                },
              }),
              _c("el-step", {
                attrs: { title: "制作", description: "选择容差值" },
              }),
              _c("el-step", {
                attrs: {
                  title: "下载图片",
                  description:
                    "等待识别图中元素完成后，鼠标移至图片上右键保存图片",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              {
                staticClass: "box_addphone",
                staticStyle: { background: "transparent" },
              },
              [
                _c(
                  "div",
                  { staticClass: "box_addphone_list" },
                  [
                    _c("div", { staticClass: "box_addphone_list_title" }, [
                      _c("b", [_vm._v("类型")]),
                    ]),
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "medium", disabled: _vm.active !== 0 },
                        model: {
                          value: _vm.leixing,
                          callback: function ($$v) {
                            _vm.leixing = $$v
                          },
                          expression: "leixing",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("公章"),
                        ]),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("法人"),
                        ]),
                        _c("el-radio-button", { attrs: { label: 2 } }, [
                          _vm._v("法人签名"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "box_addphone_list",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("div", { staticClass: "box_addphone_list_title" }, [
                      _c("b", [_vm._v("颜色")]),
                      _c(
                        "i",
                        { staticStyle: { "font-size": "8px", color: "red" } },
                        [
                          _vm._v(
                            "（颜色为最终颜色,如：选择蓝色，最终颜色为蓝色）"
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "medium", disabled: _vm.active !== 0 },
                        model: {
                          value: _vm.textcolor,
                          callback: function ($$v) {
                            _vm.textcolor = $$v
                          },
                          expression: "textcolor",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 0 } }, [
                          _vm._v("红色"),
                        ]),
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("蓝色"),
                        ]),
                        _c("el-radio-button", { attrs: { label: 2 } }, [
                          _vm._v("黑色"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "box_addphone" },
              [
                _c("el-image", {
                  staticStyle: {
                    display: "block",
                    width: "98%",
                    height: "98%",
                    margin: "1%",
                  },
                  attrs: { src: _vm.shiliuuUrl, fit: "scale-down" },
                }),
              ],
              1
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              {
                staticClass: "box_addphone",
                staticStyle: { background: "transparent" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v("容差（" + _vm._s(_vm.rongcha) + "）")]
                ),
                _c("el-slider", {
                  staticStyle: { width: "90%", margin: "0 auto" },
                  attrs: { max: 200 },
                  model: {
                    value: _vm.rongcha,
                    callback: function ($$v) {
                      _vm.rongcha = $$v
                    },
                    expression: "rongcha",
                  },
                }),
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v("1、拖动上方滑块，改变容差大小。"),
                ]),
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v("2、点击下方“ 处理图片 ”按钮。"),
                ]),
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v("3、查看右侧图片处理效果。"),
                ]),
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v("4、如图片效果良好，点击下载图片。"),
                ]),
                _c("div", { staticStyle: { "line-height": "35px" } }, [
                  _vm._v("5、如图片效果差，可重复以上"),
                  _c("b", { staticStyle: { color: "red" } }, [_vm._v("1-3步")]),
                  _vm._v("。"),
                ]),
              ],
              1
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "box_addphone" },
              [
                _c("el-image", {
                  staticStyle: {
                    display: "block",
                    width: "98%",
                    height: "98%",
                    margin: "1%",
                    position: "absolute",
                    "z-index": "1",
                  },
                  attrs: { src: _vm.tutuurlshili, fit: "scale-down" },
                }),
                _vm.tutuurlshili != ""
                  ? _c("el-image", {
                      staticStyle: {
                        display: "block",
                        width: "98%",
                        height: "98%",
                        margin: "1%",
                        position: "absolute",
                        "z-index": "9",
                      },
                      attrs: { src: _vm.img_bg },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticStyle: { width: "100%", overflow: "hidden" } },
              [
                _c("span", [_vm._v(".")]),
                _vm.active == 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "box_button",
                        staticStyle: {
                          background: "#409EFF",
                          "border-color": "#409EFF",
                          margin: "0 auto",
                        },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.activeadd()
                          },
                        },
                      },
                      [_vm._v("确认类型及颜色 ")]
                    )
                  : _vm._e(),
                _vm.active == 1
                  ? _c(
                      "el-button",
                      {
                        staticClass: "box_button",
                        staticStyle: {
                          background: "#409EFF",
                          "border-color": "#409EFF",
                          margin: "0 auto",
                        },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.activereduce()
                          },
                        },
                      },
                      [_vm._v("重选类型及颜色 ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "box_button",
                  attrs: {
                    accept: ".png,.jpg,.jpeg,.pdf,.bmp",
                    action: _vm.uploaDurls,
                    "on-preview": _vm.handlePreview,
                    "on-remove": _vm.handleRemove,
                    "on-success": _vm.handleuploadSucces,
                    "before-upload": _vm.beforeupload,
                    "on-exceed": _vm.handleExceed,
                    data: _vm.updatedata,
                    multiple: "",
                    limit: 1,
                    "show-file-list": false,
                    "file-list": _vm.fileList,
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.Downloadstatus && _vm.active == 1,
                          expression: "!Downloadstatus && active == 1",
                        },
                      ],
                      staticStyle: {
                        background: "#409EFF",
                        "border-color": "#409EFF",
                      },
                      attrs: { type: "primary" },
                    },
                    [_vm._v("上传图片 ")]
                  ),
                ],
                1
              ),
              _vm.Downloadstatus
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            background: "#409EFF",
                            "border-color": "#409EFF",
                            "margin-top": "-20px",
                          },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.updataphone()
                            },
                          },
                        },
                        [_vm._v("重新上传")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _vm.active == 2
                ? _c(
                    "el-button",
                    {
                      staticClass: "box_button",
                      staticStyle: {
                        background: "#409EFF",
                        "border-color": "#409EFF",
                      },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.chuliphone()
                        },
                      },
                    },
                    [_vm._v("处理图片 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _vm.Downloadstatus
                ? _c(
                    "el-button",
                    {
                      staticClass: "box_button",
                      staticStyle: {
                        background: "#409EFF",
                        "border-color": "#409EFF",
                      },
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleDownload()
                        },
                      },
                    },
                    [_vm._v("下载图片 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }